/**
 * Auth Verify-Email Controller (EPIC-002 / 2.4)
 *
 * Reads the verification token from the URL (?token=…) and POSTs it to
 * /auth/verify-email on connect. Toggles between three panels via
 * `hidden`:
 *
 *   loadingPanel  → visible by default
 *   successPanel  → 200 from the backend
 *   errorPanel    → no token in the URL OR any non-200 response
 *
 * The backend uniformly returns 400 invalid_or_expired_token for every
 * unhappy path (D9), so we do not branch on the error code — the UI message
 * stays generic ("Lien invalide ou expiré").
 */

import BaseController from "./base_controller.js";
import { api } from "../services/api.js";

export default class AuthVerifyEmailController extends BaseController {
  static targets = ["loadingPanel", "successPanel", "errorPanel"];

  async connect() {
    const params = new URLSearchParams(window.location.search);
    const token = (params.get("token") || "").trim();

    if (!token) {
      this.showError();
      return;
    }

    try {
      await api.verifyEmail(token);
      this.showSuccess();
    } catch {
      this.showError();
    }
  }

  showSuccess() {
    if (this.hasLoadingPanelTarget) this.loadingPanelTarget.hidden = true;
    if (this.hasErrorPanelTarget) this.errorPanelTarget.hidden = true;
    if (this.hasSuccessPanelTarget) {
      this.successPanelTarget.hidden = false;
      // Move keyboard focus into the success panel so screen readers
      // announce the new content. The CTA is the natural focus target.
      const cta = this.successPanelTarget.querySelector("a.nm-btn");
      if (cta) {
        queueMicrotask(() => cta.focus());
      }
    }
  }

  showError() {
    if (this.hasLoadingPanelTarget) this.loadingPanelTarget.hidden = true;
    if (this.hasSuccessPanelTarget) this.successPanelTarget.hidden = true;
    if (this.hasErrorPanelTarget) {
      this.errorPanelTarget.hidden = false;
      const cta = this.errorPanelTarget.querySelector("a.nm-btn");
      if (cta) {
        queueMicrotask(() => cta.focus());
      }
    }
  }
}
